import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Y si ya hice terapia?',
    a: "Perfecto. Ahora necesitas un sistema conductual. La terapia te da el 'por qué', este plan te da el 'cómo'."
  }, {
    q: '¿Esto sirve si tengo más de 40?',
    a: 'Sí. De hecho, más. Tienes la experiencia y madurez para aplicar los filtros con mayor efectividad.'
  }, {
    q: '¿Cuánto tiempo toma al día?',
    a: '20–40 minutos. Está diseñado para mujeres ocupadas que necesitan soluciones prácticas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-white" data-id="element-13">
      <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#2D2D2D] mb-12" data-id="element-14">
        FAQ
      </h2>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-15">
        {faqs.map((faq, idx) => <div key={idx} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-16">
            <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-17">
              <span className="font-medium text-lg text-[#2D2D2D]" data-id="element-18">
                {faq.q}
              </span>
              {openIndex === idx ? <ChevronUp className="w-5 h-5 text-[#D4735E]" data-id="element-19" /> : <ChevronDown className="w-5 h-5 text-[#666666]" data-id="element-20" />}
            </button>
            <AnimatePresence data-id="element-21">
              {openIndex === idx && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-22">
                  <div className="p-6 pt-0 text-[#666666] bg-white border-t border-gray-100" data-id="element-23">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}